
import { companiesList, updateCompanyService } from '../../services/CompanyServices';
import * as ActionTypes from '../ActionTypes';
export const companyListAction = (setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setCompanies, signal, setCompanyEditFlag, columnsA, columnsB, setColumns, setTableConnfig, customer_id = 0, page, items, applicationTypeKey, searchKey = 'all', searchedVal = "") => {
    return (dispatch) => {

        dispatch({ type: ActionTypes.LOADING });

        companiesList(signal, page, items, applicationTypeKey, searchKey, searchedVal).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true ) {
                setBodyStatus(true);
                let companies_data = res.data.data;
                setCompanyEditFlag(res.company_edit);
                if(res.company_edit){
                    setColumns(columnsA)
                }else{
                    setColumns(columnsB)
                }
                companies_data.map((element) => (
                    element.is_active = (element.is_active === null || element.is_active === 0) ? "Inactive" : "Active"

                ))
                companies_data.map((element) => (
                    element = getDistrictName(element)
                ))

                setRows(companies_data)
                setTableConnfig(res.data);
                setCompanies(companies_data);
                dispatch({ type: ActionTypes.LOAD_COMPANIES_LIST_SUCCESS, res });
             
            } else if (res.hasOwnProperty('success') && res.success === false) {
                if (res.success === false && Object.keys(res.message).includes('authorization_error')) {
                    setRestrictedResponse(res);
                    setRestrictedStatus(true);
                }
                dispatch({ type: ActionTypes.LOAD_COMPANIES_LIST_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}

export const updateCompanyAction = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setCompanies) => {
    return (dispatch) => {



        updateCompanyService(credentials).then((res) => {
            
            if (res.hasOwnProperty('success') && res.success === true) {
                setRows(res.data);
                let companies_data = res.data;
                companies_data.map((element) => (
                    element.is_active = (element.is_active === null || element.is_active === 0) ? "Inactive" : "Active"

                ))
                companies_data.map((element) => (
                    element = getDistrictName(element)
                ))

                setRows(companies_data)
                setCompanies(companies_data);



                dispatch({ type: ActionTypes.UPDATE_COMPANY_SUCCESS, res });
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.UPDATE_COMPANY_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
}
}
